import { Navigate } from "react-router";
import { navigationConfig } from "../config/navigation";
import ForTheRestOfUs from "./ForTheRestOfUs";

export default function ForTheRestOfUsWrapper() {
  if (navigationConfig.forTheRestOfUs.showComingSoonBadge) {
    return <Navigate to="/" replace />;
  }
  
  return <ForTheRestOfUs />;
}
